var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1854,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651.2 447.6H512v278.4a277.04 277.04 0 0 0 139.2-37.336V447.6zM651.2 688.664c83.192-48.144 139.2-138.032 139.2-241.064h-139.2v241.064z",
    fill: "#FFFFFF",
    "p-id": 1856
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 601.776c46.56 0 93.12-3.872 139.2-11.556V447.6H512v154.176z",
    fill: "#E0667D",
    "p-id": 1857
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M720.8 631.644c43.304-49.052 69.6-113.46 69.6-184.044h-69.6v184.044z",
    fill: "#D4E7F8",
    "p-id": 1858
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.8 688.664V447.6H233.6c0 103.028 56.012 192.92 139.2 241.064zM372.8 447.6v241.064A277 277 0 0 0 512 726v-278.4H372.8z",
    fill: "#FFFFFF",
    "p-id": 1859
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M372.8 700.664a12.012 12.012 0 0 1-6.008-1.612C277.232 647.224 221.6 550.872 221.6 447.6a12 12 0 0 1 12-12h139.2a12 12 0 0 1 12 12v241.064a12 12 0 0 1-12 12zM245.872 459.6c3.784 83.064 46.656 160.052 114.928 207.26V459.6H245.872z",
    fill: "#504774",
    "p-id": 1860
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 738a290.268 290.268 0 0 1-145.208-38.948 12 12 0 0 1-5.992-10.388V447.6a12 12 0 0 1 12-12H512a12 12 0 0 1 12 12v278.4a12 12 0 0 1-12 12z m-127.2-56.36a266.32 266.32 0 0 0 115.2 32.088V459.6H384.8v222.04z",
    fill: "#504774",
    "p-id": 1861
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512 738a12 12 0 0 1-12-12v-278.4a12 12 0 0 1 12-12h139.2a12 12 0 0 1 12 12v241.064a12 12 0 0 1-5.988 10.388A290.272 290.272 0 0 1 512 738z m12-278.4v254.128a266.32 266.32 0 0 0 115.2-32.088V459.6H524z",
    fill: "#504774",
    "p-id": 1862
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M651.2 700.664a11.992 11.992 0 0 1-12-12V447.6a12 12 0 0 1 12-12h139.2a12 12 0 0 1 12 12c0 103.272-55.632 199.62-145.188 251.448a12.012 12.012 0 0 1-6.012 1.616z m12-241.064v207.26c68.268-47.208 111.14-124.2 114.924-207.26H663.2zM170.996 501.36a12 12 0 0 1-11.872-10.368l-0.076-0.556c-6.332-46.428 11.48-91.92 47.644-121.7a11.996 11.996 0 1 1 15.256 18.524c-29.692 24.452-44.32 61.808-39.12 99.92l0.076 0.544a11.992 11.992 0 0 1-11.908 13.636zM853.008 501.36a12 12 0 0 1-11.908-13.588l0.076-0.556c5.204-38.144-9.42-75.496-39.116-99.952a12 12 0 0 1-1.632-16.892 11.992 11.992 0 0 1 16.892-1.632c36.164 29.78 53.976 75.268 47.644 121.688l-0.072 0.524a12.012 12.012 0 0 1-11.884 10.408z",
    fill: "#504774",
    "p-id": 1863
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512 613.772a857.508 857.508 0 0 1-256.992-39.372 11.992 11.992 0 0 1-7.324-6.468c-17.312-37.924-26.084-78.416-26.084-120.336a12 12 0 0 1 12-12h556.8a12 12 0 0 1 12 12c0 41.924-8.776 82.416-26.084 120.336a12.024 12.024 0 0 1-7.324 6.468A857.384 857.384 0 0 1 512 613.772z m-244.644-60.668A833.544 833.544 0 0 0 512 589.772c83.024 0 165.3-12.336 244.644-36.668a263.42 263.42 0 0 0 21.492-93.508H245.864a263.332 263.332 0 0 0 21.492 93.508z",
    fill: "#504774",
    "p-id": 1864
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/missing.87eb45b002f03aedc8cca023f21cbc8e.svg";
export { ForwardRef as ReactComponent };